'use client';
import React from 'react';
import NextTopLoader from 'nextjs-toploader';
import { inter } from '@/font';
import { Color } from '@/utils/constants';
import { cn } from '@/utils/common';

interface Props {
  children: React.ReactNode;
}

export const LayoutWrapper = ({ children }: Props) => {
  return (
    <body className={cn(inter.className, 'h-screen overflow-hidden')}>
      <NextTopLoader color={Color.TopLoader} showSpinner={false} />
      {children}
    </body>
  );
};
export default LayoutWrapper;
